import styles from './active-filters.module.scss';
import { type MouseEventHandler } from 'react';

const ActiveFilter = ({ value, title, onClick }: IProps) => {
	return (
		<button className={styles.activeFilter} value={value} onClick={onClick}>
			{title || value}
		</button>
	);
};

interface IProps {
	onClick: MouseEventHandler<HTMLButtonElement>;
	title?: string;
	value: string;
}

export default ActiveFilter;
